<template>
    <div class="photovoltaic_monitor">
        <!-- <div class="tree_container"> -->
       
            <!-- <div style="margin-bottom: 1.2rem;flex: 1"> -->
            <!-- <el-radio-group
                    v-model="selectType"
                    v-for="item in points"
                    :key="item.tree_unit_type_id"
                    @change="toggleTab(item.tree_unit_type_id)"
                    class="leader-style-radio"
                    size="middle"
                >
                    <el-radio-button :label="item.type_name"></el-radio-button>
                </el-radio-group> -->
            <!-- <el-form class="leader-style-form" label-width="50px">
                    <el-form-item label="类型">
                        <el-select v-model="selectType" @change="toggleTab">
                            <el-option
                                v-for="item in points"
                                :key="item.tree_unit_type_id"
                                :label="item.type_name"
                                :value="item.tree_unit_type_id"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                </el-form> -->
            <!-- </div> -->
            <!-- <me-collapes @collapesCb="collapesCb" :treeTitle="title"> -->
            <me-tree
                ref="myTree"
                :title="'采集点树'"
                :treeData="treeData"
                :treeLoading="treeLoading"
                :defaultProps="defaultProps"
                :nodeKey="'point_id'"
                :defaultCheckKeys="defaultCheckKeys"
                :treeToolBar="treeToolBar"
                @handleTreeNodeClick="handleTreeNodeClick"
                :defaultExpandedKeys="defaultCheckKeys"
                :isSingle="true"
                @handleStretchClick="handleStretchClick"
            ></me-tree>
            <!-- </me-collapes> -->
     

        <!-- </div> -->
        <Monitor :nowClick="nowClick" :contWidth="treeOuterWidth"></Monitor>
    </div>
</template>

<script>
import Tree from "@/comon/components/tree.vue";
import Collapes from "@/comon/components/collapse-block.vue";
import Monitor from "./components/monitor";
import * as api from "../../../http/Use_electricity_monitor";
import { getTreeUnitTypeTypeList, getTreeUnitListTypes } from "@/http/api";
// 解构 引入各个方法
// import { getElecInfo } from '../../../http/Use_electricity_monitor'
export default {
    components: {
        "me-tree": Tree,
        Monitor,
        "me-collapes": Collapes
    },
    data() {
        return {
            selectType: "采集点",
            selectTypeId: "",
            treeOuterWidth: 280,
            points: [],
            treeData: [],
            defaultProps: {
                children: "childList",
                label: "point_name"
            },
            // title: "采集点选择",
            treeLoading: false,
            treeToolBar: false,
            nowClick: {},
            contWidth: ""
        };
    },
    methods: {
        // 获取部门 区域
        getTreeUnitTypeTypeList() {
            getTreeUnitTypeTypeList({
                point_class_id: "001",
                point_type: 10
            }).then(res => {
                if (res && res.error_code == 0) {
                    this.points = [
                        {
                            tree_unit_type_id: "0", // 采集点
                            type_name: "采集点"
                        }
                    ];
                    if (res.bus_json.length > 0) {
                        this.points.push(...res.bus_json);
                    }
                }
            });
        },
        toggleTab(type) {
            this.selectTypeId = type;
            if (type == "0") {
                this.getUnitPointList();
            } else {
                this.getTreeUnitListTypes(type);
            }
            // this.selectPointId = point_id;
        },
        //获取采集点
        getUnitPointList() {
            api.getUnitPointList({
                point_class_id: "001",
                point_type: 10
            }).then(res => {
                if (res && res.error_code === "0") {
                    this.treeData = res.bus_json;
                    // if (!this.nowClick) {
                    //     this.$refs.myTree.handleNodeClick(res.bus_json[0]);
                    //     this.$forceUpdate();
                    // } else {
                    //     this.$refs.myTree.handleNodeClick(this.nowClick);
                    // }
                    this.$refs.myTree.handleNodeClick(res.bus_json[0]);
                    // this.nowClick = res.bus_json[0];
                }
            });
        },
        // 获取部门区域
        getTreeUnitListTypes(tree_unit_type_id) {
            getTreeUnitListTypes({
                point_class_id: "001",
                tree_unit_type_id
            }).then(res => {
                if (res && res.error_code == 0) {
                    this.treeData = res.bus_json;
                    this.transFormerData(this.treeData);
                    this.$refs.myTree.handleNodeClick(res.bus_json[0]);
                    // this.nowClick = res.bus_json[0];
                }
            });
        },
        transFormerData(datas) {
            datas.forEach(item => {
                item["point_id"] = item.tree_unit_id;
                item["point_name"] = item.tree_unit_name;
                if (item.childList && item.childList.length > 0) {
                    this.transFormerData(item.childList);
                }
            });
        },

        handleTreeNodeClick(sth) {
            // this.nowClick = sth;

            this.nowClick = { selectTypeId: this.selectTypeId, ...sth };
        },
        collapesCb(collapes) {
            this.contWidth = collapes ? false : true;
            this.loading = true;
            setTimeout(() => {
                this.loading = false;
            }, 500);
        },
        handleStretchClick(treeOuterWidth) {
            this.treeOuterWidth = treeOuterWidth
        }
    },
    created() {
        this.selectTypeId = "0";
        this.getTreeUnitTypeTypeList();
        this.getUnitPointList();
    }
};
</script>

<style lang="scss">
.photovoltaic_monitor {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    box-sizing: border-box;
    padding: 0 0 0 1rem;
    .tree_container {
        // width: 280px;
        padding-bottom: 10px;
        height: calc(100% - 10px);
    }

    .el-card {
        // border: 1px solid #ebeef5;
        // background-color: #fff;
        color: #303133;
        -webkit-transition: 0.3s;
        transition: 0.3s;
    }
    .is-alway-shadow {
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    }
}
</style>
